var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-section",
    [
      _c("w-input", {
        attrs: { label: _vm.$ct("totp"), value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      }),
      _c(
        "app-button",
        {
          staticClass: "mt",
          attrs: { disabled: !_vm.isValid },
          on: {
            click: function ($event) {
              return _vm.submit()
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.$ct("submit")) + " ")]
      ),
      _c(
        "app-button",
        {
          staticClass: "mt danger",
          on: {
            click: function ($event) {
              return _vm.cancel()
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }